import { InternalActionKeyId } from '@/define/internal_action_keys'
import { DefineDevice } from '@hid/define/define'

const huochairenFnActionKeyByRawCode = new Map<number, InternalActionKeyId>([
  [0x0b000300, InternalActionKeyId.deviceLightEffectMode],
  [0x13000000, InternalActionKeyId.deviceLightColorSwitch],
  [0x0c000100, InternalActionKeyId.deviceLightBrightnessUp],
  [0x0c000200, InternalActionKeyId.deviceLightBrightnessDown],
  [0x0d000100, InternalActionKeyId.deviceLightSpeedUp],
  [0x0d000200, InternalActionKeyId.deviceLightSpeedDown],
  [0x0e000029, InternalActionKeyId.deviceLightToggle],
  [0x0b010300, InternalActionKeyId.deviceLogoLightEffectMode],
  [0x15000000, InternalActionKeyId.deviceLightDirection],
  [0x0b020300, InternalActionKeyId.deviceSideLightEffectMode],
  [0x0b020200, InternalActionKeyId.deviceSideLightEffectPrev],
  [0x0b020100, InternalActionKeyId.deviceSideLightEffectNext],
  [0x13010000, InternalActionKeyId.deviceSideLightColorSwitch],
  [0x0c010100, InternalActionKeyId.deviceSideLightBrightnessUp],
  [0x0c010200, InternalActionKeyId.deviceSideLightBrightnessDown],
  [0x0d010100, InternalActionKeyId.deviceSideLightSpeedUp],
  [0x0d010200, InternalActionKeyId.deviceSideLightSpeedDown],
  [0x14020000, InternalActionKeyId.deviceSideLightToggle],
  [0x15020000, InternalActionKeyId.deviceSideLightDirection],
  [0x0e000007, InternalActionKeyId.deviceRestore],
  [0x0e000001, InternalActionKeyId.deviceWinKeyLock],
  [0x0e000033, InternalActionKeyId.deviceSwitchToWindowsMode],
  [0x0e000034, InternalActionKeyId.deviceSwitchToMacMode],
  [0x0e000041, InternalActionKeyId.deviceWinMacModeSwitch],
  [0x0e000042, InternalActionKeyId.deviceSwitchToProfile1],
  [0x0e000043, InternalActionKeyId.deviceSwitchToProfile2],
  [0x0e000044, InternalActionKeyId.deviceSwitchToProfile3],
  [0x0e000045, InternalActionKeyId.deviceSwitchToProfile4],
  [0x0e000046, InternalActionKeyId.deviceCycleProfiles],
  [0x85000000, InternalActionKeyId.deviceOpenWebDriver],
])

const huochairenRawCodeByActionKey = new Map<number, number>(Array.from(huochairenFnActionKeyByRawCode.entries()).map(([rawCode, actionKey]) => [actionKey, rawCode]))

const huochairenFnActionKeyOverridesByDevice = new Map<DefineDevice, ReadonlyMap<number, InternalActionKeyId>>([])

export const huochairenDeviceFunctionActionKeys: InternalActionKeyId[] = [
  InternalActionKeyId.deviceLightBrightnessDown,
  InternalActionKeyId.deviceLightBrightnessUp,
  InternalActionKeyId.deviceLightSpeedDown,
  InternalActionKeyId.deviceLightSpeedUp,
  InternalActionKeyId.deviceLightEffectMode,
  InternalActionKeyId.deviceLightColorSwitch,
  InternalActionKeyId.deviceLightToggle,
  InternalActionKeyId.deviceLogoLightEffectMode,
  InternalActionKeyId.deviceSideLightBrightnessDown,
  InternalActionKeyId.deviceSideLightBrightnessUp,
  InternalActionKeyId.deviceSideLightSpeedDown,
  InternalActionKeyId.deviceSideLightSpeedUp,
  InternalActionKeyId.deviceSideLightColorSwitch,
  InternalActionKeyId.deviceRestore,
  InternalActionKeyId.deviceSwitchToWindowsMode,
  InternalActionKeyId.deviceSwitchToMacMode,
  InternalActionKeyId.deviceWinKeyLock,
  InternalActionKeyId.deviceSwitchToProfile1,
  InternalActionKeyId.deviceSwitchToProfile2,
  InternalActionKeyId.deviceSwitchToProfile3,
  InternalActionKeyId.deviceSwitchToProfile4,
  InternalActionKeyId.deviceCycleProfiles,
  InternalActionKeyId.deviceOpenWebDriver,
]

export const getHuochairenFnActionKeyByRawCode = (rawCode: number, deviceID?: DefineDevice): InternalActionKeyId | undefined => {
  if (deviceID !== undefined) {
    const overrideMap = huochairenFnActionKeyOverridesByDevice.get(deviceID)
    const overrideActionKey = overrideMap?.get(rawCode)
    if (overrideActionKey !== undefined) {
      return overrideActionKey
    }
  }

  return huochairenFnActionKeyByRawCode.get(rawCode)
}

export const getHuochairenRawCodeByActionKey = (id: number, deviceID?: DefineDevice): number | undefined => {
  if (deviceID !== undefined) {
    const overrideMap = huochairenFnActionKeyOverridesByDevice.get(deviceID)
    if (overrideMap !== undefined) {
      for (const [rawCode, actionKey] of overrideMap.entries()) {
        if (actionKey === id) {
          return rawCode
        }
      }
    }
  }

  return huochairenRawCodeByActionKey.get(id)
}

export const getHuochairenSupportedDeviceFunctionActionKeys = (deviceID: DefineDevice): InternalActionKeyId[] => {
  void deviceID
  return [...huochairenDeviceFunctionActionKeys]
}
